import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { RecurringOrderListPage } from "@/modules/order";
import { requireAuthAndPermission } from "@/utils";

const recurringOrdersSortEnum = z.enum(["newest", "oldest"]);

const recurringOrdersSearchSchema = z.object({
  q: fallback(z.string(), "").default(""),
  page: fallback(z.number(), 1).default(1),
  sort: fallback(recurringOrdersSortEnum, "newest").default("newest")
});

export const Route = createFileRoute("/recurring-orders/")({
  validateSearch: zodValidator(recurringOrdersSearchSchema),
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Recurring Orders"
        description="Manage your recurring subscription orders."
      />
      <RecurringOrderListPage />
    </>
  )
});
